import React, { ComponentType } from 'react';
import { DropdownMenuOptionType } from '../Cells/DropdownMenuCell';
import { omit } from 'lodash';

interface WithApplicableProps {
  options: DropdownMenuOptionType[];
}

function withApplicable<T extends WithApplicableProps>(
  WrappedComponent: ComponentType<T>
): ComponentType<Omit<T, 'isApplicable'>> {
  return function WithApplicable(props: T) {
    const { options, ...restProps } = props;

    const applicableOptions = React.useMemo(() => {
      if (Array.isArray(options)) {
        return options
          .filter((option) =>
            option.isApplicable ? option.isApplicable(option) : true
          )
          .map((option) => {
            return omit(option, ['isApplicable']);
          });
      }
    }, [options]);

    return (
      <WrappedComponent {...(restProps as T)} options={applicableOptions} />
    );
  };
}

export default withApplicable;
